export enum LoaderSize {
  Small,
  Large,
}
